import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import TbxLoadingOverlay from '../TbxLoadingOverlay/TbxLoadingOverlay'

const classes = {
    progress: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
    },
}

const PageSpinner = ({ labelText = 'Loading store settings and materials...' }) => {
    const { t } = useTranslation()
    return (
        <Box sx={classes.progress}>
            <TbxLoadingOverlay
                labelText={t(labelText)}
                progressColor="secondary"
            />
        </Box>
    )
}

PageSpinner.propTypes = {
    labelText: PropTypes.string,
}

export default PageSpinner
